var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGameBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "14px",
    viewBox: "0 0 24 14",
    enableBackground: "new 0 0 24 14",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 24,
    height: 14,
    x: 0,
    y: 0,
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAOCAMAAAACJixMAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAA8FBMVEVCcfX///9CcfVCcfVC cfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVC cfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVC cfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVC cfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfVCcfX///9T bw9aAAAATnRSTlMAAFS04uq2V5KZWuj07dhg0QiRiwfbC/qrfjOH3ZTOvJgSO0vAsGc8ZvJeqkz9 bWq5oj2jy9P4ysjJ9/Xn4Y+FCtfSBQQNjOyJA4bV2ZDdy0D5AAAAAWJLR0QB/wIt3gAAAAd0SU1F B+UKFgkfFG3O0R8AAAC1SURBVBjTbY3VDsMwEATXbcrMlDIzMzP7/z+nviSWKrX7cJ69kXwAYDIr lq8oVhtjTOzt/CcOEk4il1vuPF6aPiH8BIGgFKEwzQhDNMZ5PIFkSqGFmlYz2ZyAPApiFsUllEiU A5xX8gKqqFGvoyG/arba9HSQ1mq3J0V/oD1DjPjfjDGROJ2JzGVbYGnQClrWRp0gZ9BGF1t5Cru9 BoejLk76TfUMhC/e6/52hxH2eF5f7yj7AG4kRdN3QnNTAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIx LTEwLTIyVDA2OjMxOjIwKzAzOjAwqxr2oQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0xMC0yMlQw NjozMToyMCswMzowMNpHTh0AAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGameBlue);
export default __webpack_public_path__ + "static/media/icon-game-blue.d8b6ae3fada616bec55e57faf4d94ce7.svg";
export { ForwardRef as ReactComponent };